import { render } from "./ModalFair.vue?vue&type=template&id=262650c8&scoped=true"
import script from "./ModalFair.vue?vue&type=script&lang=js"
export * from "./ModalFair.vue?vue&type=script&lang=js"

import "./ModalFair.vue?vue&type=style&index=0&id=262650c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262650c8"]])

export default __exports__